import { IonAccordion, IonAccordionGroup, IonAvatar, IonBackButton, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCol, IonContent, IonFab, IonFabButton, IonGrid, IonHeader, IonIcon, IonImg, IonItem, IonLabel, IonMenuButton, IonNote, IonPage, IonRefresher, IonRefresherContent, IonRow, IonTitle, IonToolbar, RefresherEventDetail, useIonRouter, useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react';
import { add, addCircleOutline, informationCircle, peopleOutline } from 'ionicons/icons';
import React, { useEffect, useState } from 'react';
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { Link } from 'react-router-dom';
import { useAppContext } from '../AppProvider';


const Kids: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [alertVisible, setAlertVisible] = useState<boolean>(false);
    const router = useIonRouter();
    
    const { networkStatus, getAppStatus, authKey, authenticateMember, authorizedMember, setShowLoader, level, limits, profiles, settings, kids, getKids, textLogoLoaded, fadeInTextLogo, SWTextLogo, SWFullHorizLogo, SWTextDarkLogo } = useAppContext();
    
    const kidPhotoPath = '//api.besolowise.com/kids/photos/files/'; 

    //
    // Authenticate Member
    //
    useIonViewWillEnter(() => { 
        setShowLoader(true);
        const authenticate = async () => {
            const appstat = await getAppStatus();
            if (!networkStatus && appstat === 'No') {
                router.push('/connection', 'forward');
            } else {
                const authenticated = await authenticateMember();         
                if(!authenticated || authenticated.mt == '') router.push('/login', 'forward');
            }
        };
        authenticate();
    }); 


    useEffect(() => {
        if (limits.kids > 0) {
            const fetchData = async () => {
                await getKids(authorizedMember.memberToken, limits.kids);
                window.setTimeout(() => {
                    setShowLoader(false);
                }, 2000);
            }
            fetchData();
        }
    }, [authorizedMember, limits]);


    const handleRefresh = (event: CustomEvent<RefresherEventDetail>) => {
        setLoading(true);
        setTimeout(async () => {
            await getKids(authKey.mt);
            event.detail.complete();
            setLoading(false);
        }, 2000);
    };

    const toggleAlertContent = () => setAlertVisible(!alertVisible);
    
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonBackButton color={'tertiary'}>Back</IonBackButton>
                    </IonButtons>
                    <IonTitle><IonImg className={textLogoLoaded ? 'fade-in' : 'fade-out'} src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo} onIonImgDidLoad={fadeInTextLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding account-content-bg" id="Kids">
                
                <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>

                <IonGrid>
                    <IonRow>
                        <IonCol size='12' sizeSm='7'>
                            <h1><IonIcon color={'secondary'} icon={peopleOutline}></IonIcon> My Kids<br /><span>Manage your saved Kids</span></h1>
                        </IonCol>
                        <IonCol className='ion-margin-bottom top-action-button'  size='12' sizeSm='5'>                            
                            {level?.memberLevelID >= 2 && profiles.kids < limits.kids &&
                                <IonButton className='ion-margin' color={'secondary'} routerLink='/account/kid/create' routerDirection='forward'><IonIcon icon={addCircleOutline} slot='start'></IonIcon> Add a New Kid</IonButton>
                            }
                        </IonCol>
                    </IonRow>
                </IonGrid>

                <IonAccordionGroup className='ion-margin'>
                    <IonAccordion value="info">
                        <IonItem slot='header' color={'light'}>
                            <IonLabel><IonIcon color={'tertiary'} icon={informationCircle} size='large'></IonIcon> What is a SoloWise Kid?</IonLabel>
                        </IonItem>
                        <div slot="content">                
                            <IonCard>
                                <IonCardContent>
                                    <p>There are no strict age definitions when registering a <strong>SoloWise Kid</strong>. As a general guideline, a child who is not yet old enough to have their own cell phone should definitely be registered as a <strong>Kid</strong> under your account. If the child does have a cell phone, consider having them create their own SoloWise account, so they can become a second point of contact during an emergency situation.</p>
                                </IonCardContent>
                            </IonCard>
                        </div>
                    </IonAccordion>
                </IonAccordionGroup>  

                {kids.length > 0
                    ? (kids.map((kid:any, index:any) => (                    
                        <IonCard key={index} routerDirection='forward' routerLink={`/account/kid/edit/${kid.kidToken}`}>
                            <IonCardHeader className='kid-header'>
                                {kid.kidPhoto == ''
                                    ? (<InitialsAvatar className='initials-avatar' name={`${kid.kidFirstName} ${kid.kidLastName}`} />)  
                                    : (<IonAvatar className='inline-thumbnail'><IonImg src={kid.kidPhotoThumbnailUrl} /></IonAvatar>)
                                } 
                                <IonCardTitle className='inline-name'>{kid.kidFirstName} {kid.kidLastName}</IonCardTitle>
                            </IonCardHeader>
                        </IonCard>                    
                      )))
                      : <p className='ion-text-center'>You have no recorded SoloWise Kids.</p>
                }

            </IonContent>
        </IonPage>
    );
};

export default Kids;